import api from '../../plugins/api'

export default {
  namespaced: true,
  state: {items: [], count: 0, filterParams: {}},
  actions: {
    async countUsers({commit, state}, options) {
      const count = await api.UserAdmin.count({...state.filterParams, ...options})
      commit('changeState', {count})
    },
    async fetchUsers({commit, state}, options) {
      const filterParams = {...state.filterParams, ...options}
      const items = await api.UserAdmin.fetch({...filterParams, _sort: 'createdAt:DESC'})
      commit('changeState', {items, filterParams})
    },
    fetchUserForExcel({state}) {
      return api.UserAdmin.exportExcel(state.filterParams)
    },
    fetchUserStatActive() {
      return api.UserStat.getStatActive()
    },
    fetchUserStatEmail() {
      return api.UserStat.getStatEmail()
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
  },
}
